import { useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@pu/mpp-ui/components/button';
import { Icon } from '@pu/mpp-ui/components/icon';
import { Heading } from '@pu/mpp-ui/components/typography';
import { useCSS } from '@pu/mpp-ui/hooks';
import { Path } from 'core/constants/path.constants';
import { useScreen } from 'core/contexts/screen.context';
import { IOption } from 'core/model/interfaces/menu.interface';
import { toggleSubcategoriesDrawer } from 'core/store/navigation';
import { navigationSelector } from 'core/store/navigation/selectors';
import { useAppDispatch, useAppSelector } from 'core/store/store.utils';
import { Drawer } from 'shared/components/drawer';
import { limitCharacters } from 'shared/utils/limit-strings.utils';

import './menu-subcategories-drawer.scss';

export const MenuSubcategoriesDrawer = () => {
  const css = useCSS('mpp-subcategories-drawer');
  const navigate = useNavigate();
  const { width } = useScreen();
  const dispatch = useAppDispatch();
  const { selectedEntry, subcategoriesDrawerOpen } = useAppSelector(navigationSelector);
  const options = selectedEntry.items;
  const isMobile = width <= 880;

  const isSelectedOption = (optionId: string) => (selectedEntry.selectedSubentry?.id || '') === optionId;

  const isSelectedAll = isSelectedOption('');

  const handleCloseDrawer = useCallback(() => {
    dispatch(toggleSubcategoriesDrawer(false));
  }, [dispatch]);

  const onSelect = (option: IOption | null) => {
    if (option) navigate(`${Path.CATALOG}${option.url}`);
    else navigate(`${Path.CATALOG}${selectedEntry.url}`);
    handleCloseDrawer();
  };

  useEffect(() => {
    if (!isMobile) handleCloseDrawer();
  }, [isMobile, handleCloseDrawer]);

  if (selectedEntry.items.length === 0) return null;

  return (
    <Drawer visible={subcategoriesDrawerOpen} direction="right" close={handleCloseDrawer}>
      <section className={css()} aria-label="Subcategorías">
        <Button variant="tertiary" className={css('close-button')} onClick={handleCloseDrawer}>
          <Icon name="caret-left" className={css('caret-left')} />
          Regresar
        </Button>
        <div className={css('body')}>
          <Heading>Subcategoría</Heading>
        </div>
        <ul className={css('list')}>
          <li aria-current={isSelectedAll}>
            <button
              type="button"
              className={css('chip', { selected: isSelectedAll })}
              key="todos"
              onClick={() => onSelect(null)}
            >
              Todos
            </button>
          </li>

          {options.map(option => {
            const selected = isSelectedOption(option.id);
            return (
              <li key={option.id} aria-current={selected}>
                <button type="button" className={css('chip', { selected })} onClick={() => onSelect(option)}>
                  {limitCharacters(option.name, 24)}
                </button>
              </li>
            );
          })}
        </ul>
      </section>
    </Drawer>
  );
};
